import './standalone.scss';

import React, { useState } from 'react';
import { PaginationListStandalone } from 'react-bootstrap-table2-paginator';

interface CustomPaginationProps {
  paginationProps: {
    page: number;
    sizePerPage: number;
    totalSize: number;
    onPageChange: (page: number) => void;
  };
}

const StandalonePagination: React.FC<CustomPaginationProps> = ({
  paginationProps,
}) => {
  const { page, totalSize, sizePerPage, onPageChange } = paginationProps;
  const totalPages = Math.ceil(totalSize / sizePerPage);
  const [inputPage, setInputPage] = useState(page);

  const handleGo = () => {
    if (inputPage >= 1 && inputPage <= totalPages) {
      onPageChange(inputPage);
    }
  };

  return (
    <div
      className="standalone-pagination"
      style={{ display: 'flex', alignItems: 'center' }}
    >
      <PaginationListStandalone {...paginationProps} />

      {totalPages > 1 && (
        <div
          style={{ marginLeft: '1rem', display: 'flex', alignItems: 'center' }}
        >
          <label
            htmlFor="go-to-page"
            style={{ marginRight: 4, fontSize: '0.7rem' }}
          >
            Go To
          </label>
          <input
            id="go-to-page"
            // type="number"
            className="form-control"
            value={inputPage}
            onChange={(e) => setInputPage(Number(e.target.value))}
            style={{ width: 50, marginRight: 4 }}
            min={1}
            max={totalPages}
          />
          <button className="btn btn-secondary" onClick={handleGo}>
            Go
          </button>
        </div>
      )}
    </div>
  );
};

export default StandalonePagination;
